"use strict";
/* eslint-disable react/prop-types */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var focus_trap_react_1 = __importDefault(require("focus-trap-react"));
var Icon_1 = __importDefault(require("../../../Icon/Icon"));
var comments_1 = require("../../state/comments");
var comments_2 = require("../../actions/comments");
var sequences_1 = require("../../utils/sequences");
var CommentReply_1 = __importDefault(require("../CommentReply"));
var CommentHeader_1 = require("../CommentHeader");
var TextArea_1 = __importDefault(require("../TextArea"));
function saveComment(comment, store) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            store.dispatch(comments_2.updateComment(comment.localId, {
                mode: 'saving',
            }));
            try {
                store.dispatch(comments_2.updateComment(comment.localId, {
                    mode: 'default',
                    text: comment.newText,
                    remoteId: comment.remoteId,
                    author: comment.author,
                    date: comment.date,
                }));
            }
            catch (err) {
                /* eslint-disable-next-line no-console */
                console.error(err);
                store.dispatch(comments_2.updateComment(comment.localId, {
                    mode: 'save_error',
                }));
            }
            return [2 /*return*/];
        });
    });
}
function doDeleteComment(comment, store) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            store.dispatch(comments_2.updateComment(comment.localId, {
                mode: 'deleting',
            }));
            try {
                store.dispatch(comments_2.deleteComment(comment.localId));
            }
            catch (err) {
                /* eslint-disable-next-line no-console */
                console.error(err);
                store.dispatch(comments_2.updateComment(comment.localId, {
                    mode: 'delete_error',
                }));
            }
            return [2 /*return*/];
        });
    });
}
function doResolveComment(comment, store) {
    store.dispatch(comments_2.resolveComment(comment.localId));
}
var CommentComponent = /** @class */ (function (_super) {
    __extends(CommentComponent, _super);
    function CommentComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommentComponent.prototype.renderReplies = function (_a) {
        var e_1, _b;
        var _this = this;
        var _c = _a === void 0 ? {} : _a, _d = _c.hideNewReply, hideNewReply = _d === void 0 ? false : _d;
        var _e = this.props, comment = _e.comment, isFocused = _e.isFocused, store = _e.store, user = _e.user, strings = _e.strings;
        if (!comment.remoteId) {
            // Hide replies UI if the comment itself isn't saved yet
            return react_1["default"].createElement(react_1["default"].Fragment, null);
        }
        var onChangeNewReply = function (value) {
            store.dispatch(comments_2.updateComment(comment.localId, {
                newReply: value,
            }));
        };
        var sendReply = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var replyId, reply;
            return __generator(this, function (_a) {
                e.preventDefault();
                replyId = sequences_1.getNextReplyId();
                reply = comments_1.newCommentReply(replyId, user, Date.now(), {
                    text: comment.newReply,
                    mode: 'default',
                });
                store.dispatch(comments_2.addReply(comment.localId, reply));
                store.dispatch(comments_2.updateComment(comment.localId, {
                    newReply: '',
                }));
                return [2 /*return*/];
            });
        }); };
        var onClickCancelReply = function (e) {
            e.preventDefault();
            store.dispatch(comments_2.updateComment(comment.localId, {
                newReply: '',
            }));
            store.dispatch(comments_2.setFocusedComment(null));
            // Stop the event bubbling so that the comment isn't immediately refocused
            e.stopPropagation();
        };
        var replies = [];
        var replyBeingEdited = false;
        try {
            for (var _f = __values(comment.replies.values()), _g = _f.next(); !_g.done; _g = _f.next()) {
                var reply = _g.value;
                if (reply.mode === 'saving' || reply.mode === 'editing') {
                    replyBeingEdited = true;
                }
                if (!reply.deleted) {
                    replies.push(react_1["default"].createElement(CommentReply_1["default"], { key: reply.localId, store: store, user: user, comment: comment, reply: reply, strings: strings, isFocused: isFocused }));
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_g && !_g.done && (_b = _f["return"])) _b.call(_f);
            }
            finally { if (e_1) throw e_1.error; }
        }
        // Hide new reply if a reply is being edited as well
        var newReplyHidden = hideNewReply || replyBeingEdited;
        var replyForm = react_1["default"].createElement(react_1["default"].Fragment, null);
        if (!newReplyHidden && (isFocused || comment.newReply)) {
            replyForm = (react_1["default"].createElement("form", { onSubmit: sendReply },
                react_1["default"].createElement(TextArea_1["default"], { className: "comment__reply-input", placeholder: "Enter your reply...", value: comment.newReply, onChange: onChangeNewReply }),
                react_1["default"].createElement("div", { className: "comment__reply-actions" },
                    react_1["default"].createElement("button", { disabled: comment.newReply.length === 0, type: "submit", className: "comment__button comment__button--primary" }, strings.REPLY),
                    react_1["default"].createElement("button", { type: "button", onClick: onClickCancelReply, className: "comment__button" }, strings.CANCEL))));
        }
        else if (replies.length === 0) {
            // If there is no form, or replies, don't add any elements to the dom
            // This is in case there is a warning after the comment, some special styling
            // is added if that element is that last child so we can't have any hidden elements here.
            return react_1["default"].createElement(react_1["default"].Fragment, null);
        }
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement("ul", { className: "comment__replies" }, replies),
            replyForm));
    };
    CommentComponent.prototype.renderCreating = function () {
        var _this = this;
        var _a = this.props, comment = _a.comment, store = _a.store, strings = _a.strings, isFocused = _a.isFocused;
        var onChangeText = function (value) {
            store.dispatch(comments_2.updateComment(comment.localId, {
                newText: value,
            }));
        };
        var onSave = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        return [4 /*yield*/, saveComment(comment, store)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var onCancel = function (e) {
            e.preventDefault();
            store.dispatch(comments_2.deleteComment(comment.localId));
        };
        var descriptionId = "comment-description-" + comment.localId;
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(CommentHeader_1.CommentHeader, { descriptionId: descriptionId, commentReply: comment, store: store, strings: strings, focused: isFocused }),
            react_1["default"].createElement("form", { onSubmit: onSave },
                react_1["default"].createElement(TextArea_1["default"], { focusTarget: isFocused, className: "comment__input", value: comment.newText, onChange: onChangeText, placeholder: "Enter your comments...", additionalAttributes: {
                        'aria-describedby': descriptionId
                    } }),
                react_1["default"].createElement("div", { className: "comment__actions" },
                    react_1["default"].createElement("button", { disabled: comment.newText.length === 0, type: "submit", className: "comment__button comment__button--primary" }, strings.COMMENT),
                    react_1["default"].createElement("button", { type: "button", onClick: onCancel, className: "comment__button" }, strings.CANCEL)))));
    };
    CommentComponent.prototype.renderEditing = function () {
        var _this = this;
        var _a = this.props, comment = _a.comment, store = _a.store, strings = _a.strings, isFocused = _a.isFocused;
        var onChangeText = function (value) {
            store.dispatch(comments_2.updateComment(comment.localId, {
                newText: value,
            }));
        };
        var onSave = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        return [4 /*yield*/, saveComment(comment, store)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var onCancel = function (e) {
            e.preventDefault();
            store.dispatch(comments_2.updateComment(comment.localId, {
                mode: 'default',
                newText: comment.text,
            }));
        };
        var descriptionId = "comment-description-" + comment.localId;
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(CommentHeader_1.CommentHeader, { descriptionId: descriptionId, commentReply: comment, store: store, strings: strings, focused: isFocused }),
            react_1["default"].createElement("form", { onSubmit: onSave },
                react_1["default"].createElement(TextArea_1["default"], { focusTarget: isFocused, className: "comment__input", value: comment.newText, additionalAttributes: {
                        'aria-describedby': descriptionId
                    }, onChange: onChangeText }),
                react_1["default"].createElement("div", { className: "comment__actions" },
                    react_1["default"].createElement("button", { disabled: comment.newText.length === 0, type: "submit", className: "comment__button comment__button--primary" }, strings.SAVE),
                    react_1["default"].createElement("button", { type: "button", onClick: onCancel, className: "comment__button" }, strings.CANCEL))),
            this.renderReplies({ hideNewReply: true })));
    };
    CommentComponent.prototype.renderSaving = function () {
        var _a = this.props, comment = _a.comment, store = _a.store, strings = _a.strings, isFocused = _a.isFocused;
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(CommentHeader_1.CommentHeader, { commentReply: comment, store: store, strings: strings, focused: isFocused }),
            react_1["default"].createElement("p", { className: "comment__text" }, comment.text),
            react_1["default"].createElement("div", { className: "comment__progress" }, strings.SAVING),
            this.renderReplies({ hideNewReply: true })));
    };
    CommentComponent.prototype.renderSaveError = function () {
        var _this = this;
        var _a = this.props, comment = _a.comment, store = _a.store, strings = _a.strings, isFocused = _a.isFocused;
        var onClickRetry = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        return [4 /*yield*/, saveComment(comment, store)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(CommentHeader_1.CommentHeader, { commentReply: comment, store: store, strings: strings, focused: isFocused }),
            react_1["default"].createElement("p", { className: "comment__text" }, comment.text),
            this.renderReplies({ hideNewReply: true }),
            react_1["default"].createElement("div", { className: "comment__error" },
                strings.SAVE_ERROR,
                react_1["default"].createElement("button", { type: "button", className: "comment__button", onClick: onClickRetry }, strings.RETRY))));
    };
    CommentComponent.prototype.renderDeleteConfirm = function () {
        var _this = this;
        var _a = this.props, comment = _a.comment, store = _a.store, strings = _a.strings, isFocused = _a.isFocused;
        var onClickDelete = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        return [4 /*yield*/, doDeleteComment(comment, store)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var onClickCancel = function (e) {
            e.preventDefault();
            store.dispatch(comments_2.updateComment(comment.localId, {
                mode: 'default',
            }));
        };
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(CommentHeader_1.CommentHeader, { commentReply: comment, store: store, strings: strings, focused: isFocused }),
            react_1["default"].createElement("p", { className: "comment__text" }, comment.text),
            react_1["default"].createElement("div", { className: "comment__confirm-delete" },
                strings.CONFIRM_DELETE_COMMENT,
                react_1["default"].createElement("button", { type: "button", className: "comment__button", onClick: onClickCancel }, strings.CANCEL),
                react_1["default"].createElement("button", { type: "button", className: "comment__button comment__button--primary", onClick: onClickDelete }, strings.DELETE)),
            this.renderReplies({ hideNewReply: true })));
    };
    CommentComponent.prototype.renderDeleting = function () {
        var _a = this.props, comment = _a.comment, store = _a.store, strings = _a.strings, isFocused = _a.isFocused;
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(CommentHeader_1.CommentHeader, { commentReply: comment, store: store, strings: strings, focused: isFocused }),
            react_1["default"].createElement("p", { className: "comment__text" }, comment.text),
            react_1["default"].createElement("div", { className: "comment__progress" }, strings.DELETING),
            this.renderReplies({ hideNewReply: true })));
    };
    CommentComponent.prototype.renderDeleteError = function () {
        var _this = this;
        var _a = this.props, comment = _a.comment, store = _a.store, strings = _a.strings, isFocused = _a.isFocused;
        var onClickRetry = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        return [4 /*yield*/, doDeleteComment(comment, store)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var onClickCancel = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                e.preventDefault();
                store.dispatch(comments_2.updateComment(comment.localId, {
                    mode: 'default',
                }));
                return [2 /*return*/];
            });
        }); };
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(CommentHeader_1.CommentHeader, { commentReply: comment, store: store, strings: strings, focused: isFocused }),
            react_1["default"].createElement("p", { className: "comment__text" }, comment.text),
            this.renderReplies({ hideNewReply: true }),
            react_1["default"].createElement("div", { className: "comment__error" },
                strings.DELETE_ERROR,
                react_1["default"].createElement("button", { type: "button", className: "comment__button", onClick: onClickCancel }, strings.CANCEL),
                react_1["default"].createElement("button", { type: "button", className: "comment__button", onClick: onClickRetry }, strings.RETRY))));
    };
    CommentComponent.prototype.renderDefault = function () {
        var _a = this.props, comment = _a.comment, store = _a.store, strings = _a.strings, isFocused = _a.isFocused;
        // Show edit/delete buttons if this comment was authored by the current user
        var onEdit;
        var onDelete;
        if (comment.author === null || this.props.user && this.props.user.id === comment.author.id) {
            onEdit = function () {
                store.dispatch(comments_2.updateComment(comment.localId, {
                    mode: 'editing',
                    newText: comment.text,
                }));
            };
            onDelete = function () {
                store.dispatch(comments_2.updateComment(comment.localId, {
                    mode: 'delete_confirm',
                }));
            };
        }
        var notice = '';
        if (!comment.remoteId) {
            // Save the page to add this comment
            notice = strings.SAVE_PAGE_TO_ADD_COMMENT;
        }
        else if (comment.text !== comment.originalText) {
            // Save the page to save this comment
            notice = strings.SAVE_PAGE_TO_SAVE_COMMENT_CHANGES;
        }
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(CommentHeader_1.CommentHeader, { commentReply: comment, store: store, strings: strings, onResolve: doResolveComment, onEdit: onEdit, onDelete: onDelete, focused: isFocused }),
            react_1["default"].createElement("p", { className: "comment__text" }, comment.text),
            notice &&
                react_1["default"].createElement("div", { className: "comment__notice-placeholder" },
                    react_1["default"].createElement("div", { className: "comment__notice", role: "status" },
                        react_1["default"].createElement(Icon_1["default"], { name: "info-circle" }),
                        notice)),
            this.renderReplies()));
    };
    CommentComponent.prototype.render = function () {
        var _this = this;
        var inner;
        switch (this.props.comment.mode) {
            case 'creating':
                inner = this.renderCreating();
                break;
            case 'editing':
                inner = this.renderEditing();
                break;
            case 'saving':
                inner = this.renderSaving();
                break;
            case 'save_error':
                inner = this.renderSaveError();
                break;
            case 'delete_confirm':
                inner = this.renderDeleteConfirm();
                break;
            case 'deleting':
                inner = this.renderDeleting();
                break;
            case 'delete_error':
                inner = this.renderDeleteError();
                break;
            default:
                inner = this.renderDefault();
                break;
        }
        var onClick = function () {
            _this.props.store.dispatch(comments_2.setFocusedComment(_this.props.comment.localId, { updatePinnedComment: false, forceFocus: _this.props.isFocused && _this.props.forceFocus }));
        };
        var onDoubleClick = function () {
            _this.props.store.dispatch(comments_2.setFocusedComment(_this.props.comment.localId, { updatePinnedComment: true, forceFocus: true }));
        };
        var top = this.props.layout.getCommentPosition(this.props.comment.localId);
        return (react_1["default"].createElement(focus_trap_react_1["default"], { focusTrapOptions: {
                preventScroll: true,
                clickOutsideDeactivates: true,
                onDeactivate: function () {
                    _this.props.store.dispatch(comments_2.setFocusedComment(null, { updatePinnedComment: true, forceFocus: false }));
                },
                initialFocus: '[data-focus-target="true"]',
            }, active: this.props.isFocused && this.props.forceFocus },
            react_1["default"].createElement("li", { tabIndex: -1, "data-focus-target": this.props.isFocused && !['creating', 'editing'].includes(this.props.comment.mode), key: this.props.comment.localId, className: "comment comment--mode-" + this.props.comment.mode + " " + (this.props.isFocused ? 'comment--focused' : ''), style: {
                    position: 'absolute',
                    top: top + "px",
                    display: this.props.isVisible ? 'block' : 'none',
                }, "data-comment-id": this.props.comment.localId, onClick: onClick, onDoubleClick: onDoubleClick }, inner)));
    };
    CommentComponent.prototype.componentDidMount = function () {
        var element = react_dom_1["default"].findDOMNode(this);
        if (element instanceof HTMLElement) {
            this.props.layout.setCommentElement(this.props.comment.localId, element);
            if (this.props.isVisible) {
                this.props.layout.setCommentHeight(this.props.comment.localId, element.offsetHeight);
            }
        }
    };
    CommentComponent.prototype.componentWillUnmount = function () {
        this.props.layout.setCommentElement(this.props.comment.localId, null);
    };
    CommentComponent.prototype.componentDidUpdate = function () {
        var element = react_dom_1["default"].findDOMNode(this);
        // Keep height up to date so that other comments will be moved out of the way
        if (this.props.isVisible && element instanceof HTMLElement) {
            this.props.layout.setCommentHeight(this.props.comment.localId, element.offsetHeight);
        }
    };
    return CommentComponent;
}(react_1["default"].Component));
exports["default"] = CommentComponent;
